import {
  Ancillaries,
  GenericItem,
  Inclusive,
  PostalAddress,
  SelectedExtra,
  SelectedHotel,
  SelectedRoom,
  SelectedTripInsurance,
  SelectedVehicle
} from '@com-delta-idp/mnx-trip-management-shared-ui';

export const HotelPreferencesMock: GenericItem[] = [
  { name: 'Queen Bed', code: 'HOT,,option,BEDS,QUEN' },
  { name: 'Non-Smoking', code: 'HOT,,option,SMOKE_PREF,NSMK' }
];

export const HotelInclusivesMock: Inclusive[] = [
  { desc: 'City Tax Not Included', subTypeCode: 'ADV' },
  { desc: 'Group Booking Policy', subTypeCode: 'T&C' },
  {
    desc: 'Champagne and Macarons',
    infoKey: 'VALA/PREREGIS',
    subTypeCode: 'T&C'
  }
];

export const SelectedRoomMock: SelectedRoom = {
  id: 1,
  desc: 'Executive Suite & Sofa',
  reservedForPassengers: ['b76558a7-33b3-44de-a06e-ef6cd31bacca'],
  preferences: HotelPreferencesMock,
  addedValues: [
    { desc: 'City Tax Not Included', infoKey: 'VALA/PAR_CITYTAX' },
    { desc: 'Group Booking Policy' }
  ]
};
export const PostalAddressMock: PostalAddress = {
  street: '4 rue de la Pepiniere',
  cityName: 'Paris',
  country: { name: 'France' },
  postalCode: '75008'
};

export const SelectedTripInsuranceMock: SelectedTripInsurance[] = [
  {
    confirmationNum: 'confirmed',
    currencyCode: 'USD',
    totalPrice: '152.00',
    reservedForPassengers: ['b76558a7-33b3-44de-a06e-ef6cd31bacca'],
    insurancePlans: [
      {
        code: 'TRAVEL_PROTECTION_PLUS',
        desc: 'Part A: Pre-departure Benefits<sup>1</sup>',
        details: [
          'Cancel for any reason before departure (must purchase within 7 days of deposit)',
          'Up to 100% cash reimbursement',
          'Lowest Price Guarantee (must purchase within 7 days of deposit)'
        ]
      },
      {
        code: 'TRAVEL_PROTECTION_PLUS',
        desc: 'Part B: Post-departure Benefits (Vacation Protector)<sup>2,3</sup>',
        details: [
          'Trip Interruption Protection',
          'Travel Delay',
          'Baggage Protection',
          'Emergency Medical Care and Transportation',
          '24/7 Travel Assistance',
          'Benefits for pre-existing medical conditions  (must purchase within 14 days of deposit)'
        ]
      }
    ]
  }
];

export const SelectedHotelMock: SelectedHotel = {
  confirmationNum: 'TSTTST03957455Q',
  vendorName: 'Maison Albar Hotels Le Diamond',
  checkinDt: '2024-09-14T00:00:00',
  checkoutDt: '2024-09-18T00:00:00',
  rooms: [
    SelectedRoomMock,
    {
      ...SelectedRoomMock,
      confirmationNum: 'TSTTST03957455Q',
      preferences: [],
      reservedForPassengers: ['5473d53f-79b9-468b-98f2-cafe336a551c']
    }
  ],
  nightsBooked: 4,
  address: PostalAddressMock,
  rating: '5',
  addedValues: HotelInclusivesMock,
  link: 'https://static.deltavacations.com/images/entity/hotel/kef/kef_canopy_canopy/kef_canopy_canopy-1.jpg'
};

export const SelectedActivityMock: SelectedExtra[] = [
  {
    name: 'Catamran Fun',
    link: 'https://static.deltavacations.com/images/entity/activity/kef/kef_kefdmc_golcir.jpg',
    passengerResourceId: ['b76558a7-33b3-44de-a06e-ef6cd31bacca'],
    confirmationNum: '17622966-0007',
    desc: '2 choices',
    passengerCnt: 1,
    activityDt: '2024-09-16T00:00',
    addedValues: [
      {
        subTypeCode: 'ADV',
        desc: 'Booking Restrictions'
      },
      {
        desc: 'Preregistration',
        infoKey: 'VALA/PREREGIS'
      }
    ]
  },
  {
    name: 'Catamran Tour',
    link: 'https://static.deltavacations.com/images/entity/activity/kef/kef_kefdmc_north.jpg',
    passengerResourceId: ['b76558a7-33b3-44de-a06e-ef6cd31bacca'],
    confirmationNum: '',
    desc: '11 AM',
    passengerCnt: 1,
    activityDt: '',
    addedValues: [
      {
        desc: 'Activity Info'
      },
      {
        subTypeCode: 'ADV',
        desc: 'Booking Restrictions'
      },
      {
        desc: 'Enterprise Exclusive',
        infoKey: 'VALA/ETUK_EXCLUSIVE'
      }
    ]
  }
];

export const SelectedTransferMock: SelectedExtra[] = [
  {
    serviceDesc: 'Private Nonstop SUV',
    serviceType: 'CUN_TRAFIC_PRVSUV',
    serviceDetails:
      'Upgrade your experience to private, nonstop, roundtrip transportation between the airport and your hotel, in a dedicated air-conditioned SUV.',
    link: 'https://static.deltavacations.com/images/entity/car_vendor/alamo/alamo-car_type-lcar.jpg',
    passengerResourceId: [
      'b76558a7-33b3-44de-a06e-ef6cd31bacca',
      '5473d53f-79b9-468b-98f2-cafe336a551c'
    ],
    confirmationNum: '17622966-0009',
    passengerCnt: 1,
    startDt: '2024-09-16T00:00',
    addedValues: [
      {
        desc: 'Private Nonstop SUV Transfer up to 5 people'
      },
      {
        desc: 'Enterprise Exclusive',
        infoKey: 'VALA/ETUK_EXCLUSIVE'
      }
    ]
  }
];
export const SelectedVehicleMock: SelectedVehicle = {
  confirmationNum: '17743677-0005',
  vendorName: 'Enterprise Rent-A-Car - France',
  desc: 'Mini 2 door/Manual/Air (Renault Twingo or similar)',
  primaryDriver: 'b76558a7-33b3-44de-a06e-ef6cd31bacca',
  daysBooked: 4,
  pickUp: {
    description: 'PARIS ROISSY CDG AIRPORT',
    countryCode: 'FR',
    timeVisit: '2024-09-14T11:01:00',
    alwaysOpen: false
  },
  dropOff: {
    description: 'PARIS ROISSY CDG AIRPORT',
    countryCode: 'FR',
    timeVisit: '2024-09-18T11:59:00',
    alwaysOpen: false
  },
  passengerCapacity: 4,
  bagCapacity: 1,
  addedValues: [
    { desc: 'NEW Car Rental Requirement', infoKey: 'VALA/CDG_RNTL_REQ' },
    { desc: 'What is EXCLUSIVE?', infoKey: 'VALA/FRANCE_EXCL_FR' }
  ],
  preferences: [
    { name: 'Bike rack', code: 'string' },
    { name: 'Ski Rack', code: 'string' }
  ],
  link: 'https://static.deltavacations.com/images/entity/car_vendor/entuk/entuk-car_type-mbmr.jpg'
};

export const AncillariesMock: Ancillaries = {
  accommodations: [SelectedHotelMock],
  activities: SelectedActivityMock,
  groundTransportations: SelectedTransferMock,
  vehicles: [SelectedVehicleMock],
  tripInsurance: SelectedTripInsuranceMock
};
